import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EquipmentReservation } from './equipment-reservation';
import { StatusEnum, getStatusNumericValue } from 'src/app/shared/models';
import { environment } from 'src/environments/environment';

type EquipmentReservationCreatePayload = Omit<
  EquipmentReservation,
  'id' | 'equipmentName' | 'projectName' | 'timePart' | 'statusEvents' | 'timeStamp'
>;

@Injectable({
  providedIn: 'root'
})
export class EquipmentReservationService {

  private apiUrl = `${environment.apiRoot}`;

  constructor(private http:HttpClient) { }
  get(projectId: number): Observable<EquipmentReservation[]> {
    const url = `${this.apiUrl}Projects/${projectId}/EquipmentReservations`;
    return this.http.get<EquipmentReservation[]>(url);
  }

  getById(projectId: number, id: number): Observable<EquipmentReservation | null> {
    const url = `${this.apiUrl}Projects/${projectId}/EquipmentReservations/${id}`;
    return this.http.get<EquipmentReservation | null>(url);
  }
  getByDateRange(projectId: number, startDate: Date, endDate: Date): Observable<EquipmentReservation[]> {
    const url = `${this.apiUrl}Projects/${projectId}/EquipmentReservations/byDates?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`;
    return this.http.get<EquipmentReservation[]>(url);
  }

  create(projectId: number, reservation: EquipmentReservation): Observable<EquipmentReservation> {
    const url = `${this.apiUrl}Projects/${projectId}/EquipmentReservations`;
    return this.http.post<EquipmentReservation>(url, { ...reservation, projectId });
  }
  postBatchReservations(projectId: number, reservations: EquipmentReservationCreatePayload[]): Observable<EquipmentReservation[]> {
    const url = `${this.apiUrl}Projects/${projectId}/EquipmentReservations/batch`;
    return this.http.post<EquipmentReservation[]>(url, reservations.map(r => ({ ...r, projectId })));
  }

  update(projectId: number, id: number, reservation: EquipmentReservation): Observable<void> {
    const url = `${this.apiUrl}Projects/${projectId}/EquipmentReservations/${id}`;
    return this.http.put<void>(url, { ...reservation, projectId });
  }

  delete(projectId:number, id: number): Observable<void> {
    const url = `${this.apiUrl}Projects/${projectId}/EquipmentReservations/${id}`;
    return this.http.delete<void>(url);
  }

  approve(projectId: number, id: number): Observable<void> {
    const url = `${this.apiUrl}Projects/${projectId}/EquipmentReservations/${id}/Approve`;
    return this.http.put<void>(url, null);
  }

  setStatus(projectId: number, id: number, status: StatusEnum): Observable<void> {
    const url = `${this.apiUrl}Projects/${projectId}/EquipmentReservations/${id}/SetStatus`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put<void>(url, getStatusNumericValue(status), { headers });
  }
  getWaitingNotices(projectId: number): Observable<EquipmentReservation[]> {
    return this.http.get<EquipmentReservation[]>(`${this.apiUrl}Projects/${projectId}/EquipmentReservations/waitingNotices`);
  }

  getWaitingNoticesCount(projectId: number): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}Projects/${projectId}/EquipmentReservations/waitingNoticesCount`);
  }
}
export interface MultiReservationPayload{

    projectId: number;
    equipmentId: string;
    reservations:Reservation[];
    info: string;
    userName: string;
    userEmail: string;
    userPhone: string;
    operator: string;
    status: StatusEnum.Waiting;
    ownerId:string;

}
export interface Reservation{
  startDate: Date;
  duration: string;
  endDate: Date;
}
